import { render, staticRenderFns } from "./DeliveryInfoPanel.vue?vue&type=template&id=0dadd7df&scoped=true&"
import script from "./DeliveryInfoPanel.vue?vue&type=script&lang=js&"
export * from "./DeliveryInfoPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dadd7df",
  null
  
)

export default component.exports